window.$ = window.jQuery = require('jquery');
import {Chart, registerables} from 'chart.js';

Chart.register(...registerables);
require('@coreui/coreui');
window.swal = require('sweetalert2');
window.multiselect = require('multiselect');
require('select2');
$.fn.select2.defaults.set("theme", "bootstrap4");
$.fn.select2.defaults.set("language", require('select2/src/js/select2/i18n/pt-BR'));
require('./multitem');

window.bsCustomFileInput = require('bs-custom-file-input');

require('./router');
require('./form');
require('./inputmasks');
require('./view');
require('./cookies');
require('./address/index');
require('./address/city_select');
require('../images');
require('../searchcep');
require('./charts');


swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000
});

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$('#permissions').multiSelect({
    selectableOptgroup: true,
    selectableHeader: "<div class='custom-header'>Disponíveis</div>",
    selectionHeader: "<div class='custom-header'>Vinculadas</div>"
});
$('.flipswitch').each(function () {
    $(this).click(function () {
        $(this).toggleClass("bg-success");
    });
});

function cloneline(list) {
    let more = 0;
    let item = null;
    if ($(this).hasClass("item_index")) {
        $.each(list, function () {
            //debugger;
            const input = $(this).find(".item_index");


            const index = parseInt(input.attr("name").match(/\[(\d+)\](?!.*\[\d+\])/)[1]);

            if (item == null) {
                more = index;
                item = $(this).clone();
            }

            if (index > more) {
                more = index;
                item = $(this).clone();
            }


        });
    } else {
        item = list.first().clone();
    }
    return item;
}

function increaseIndex(name) {
    if (name !== undefined) {
        let index = parseInt(name.match(/\[(\d+)\](?!.*\[\d+\])/)[1]);
        index = index + 1;
        name = name.replace(/\[(\d+)\](?!.*\[\d+\])/, '[' + index + ']');
    }
    return name;
}
